export enum shuttlesAndRoutesTypesEnum {
  ROUTES_REQUEST = 'FETCH_ROUTES_REQUEST',
  FAILURE_SHUTTLES = 'FETCH_SHUTTLES_FAILURE',
  SET_SHUTTLES = 'SET_SHUTTLES',
  SHUTTLES_REQUEST = 'FETCH_SHUTTLES_REQUEST',
  FAILURE_ROUTES = 'FETCH_ROUTES_FAILURE',
  SET_ROUTES = 'SET_ROUTES',
}
